// The iOS app pushes a page's screen before the page renders, and UIKit
// doesn't draw a title given to a screen once its push is under way, so a
// pushed screen stayed untitled until the push finished. When Turbo already
// holds the page (preloaded, or cached from an earlier visit), its title goes
// to the app just ahead of the visit, so the new screen starts with it.
//
// Listening on window runs after the document's listeners, so a visit one of
// them cancelled (the navigation guard, say) sends nothing.
window.addEventListener("turbo:before-visit", (event) => {
  const nativeApp = window.webkit?.messageHandlers?.nativeApp;
  if (!nativeApp || event.defaultPrevented) return;

  // A snapshot cached on leaving a page shares the live <head>, so the title
  // comes from the head elements Turbo captured with it, as its preview does.
  const snapshot = Turbo.session.view.snapshotCache.get(new URL(event.detail.url));
  const titleElement = snapshot?.headSnapshot.provisionalElements.find((element) => element.tagName === "TITLE");
  const title = titleElement?.textContent.replace(/\s+/g, " ").trim();
  if (!title) return;

  nativeApp.postMessage({ name: "next_page_title", url: event.detail.url, title });
});
